import * as React from 'react'
import {Nullable} from '../../../../../app/TypeHelpers'
import {BlockSpacer} from '../../../../../styledComponents/ResponsiveConvenience'
import NatResidentApplicationDetailConfirmItem from '../../common/resident/NatResidentApplicationDetailConfirmItem'
import {APPLY_CATEGORY} from '../../../../../CodeMaster'
import {convertToRoomNumberForResident} from '../../../../common/util/Natutil'
import {
    NatResidentLoginInfoSessionStorageHelper,
    ResidentLoginInfoSessionStorageKey
} from '../../../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {getFormattedDate, getFormattedLastDate} from '../helper/NatBikeParkingUseWithdrawalApplyHelper'

interface Props {
    applicantFamilyName: Nullable<string>
    applicantFirstName: Nullable<string>
    withdrawalArea: Nullable<string>
    withdrawalDate: Nullable<string>
    bikeCarryingOutDate: Nullable<string>
    applyFlag?: boolean
}

const NatResidentBikeParkingUseWithdrawalApplyConfirm = ({ applyFlag = true, ...otherProps}: Props) => {
    const {
        applicantFamilyName, applicantFirstName, withdrawalArea, withdrawalDate, bikeCarryingOutDate
    } = otherProps

    const applyCategoryLabel = APPLY_CATEGORY.BIKE_PARKING_USE_ADMIT_CANCEL.label

    const withdrawalDateLabel = (withdrawalDate) ?
        getFormattedLastDate(withdrawalDate) : ''

    const bikeCarryingOutDateLabel = (bikeCarryingOutDate) ?
        getFormattedDate(bikeCarryingOutDate) : ''

    const applicantRoom = NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
        NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_RIDGENAME) + ' ' +
        convertToRoomNumberForResident(
            NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER)
        )

    return (<>
        {applyFlag === true &&
            <>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請区分'}
                    items={[applyCategoryLabel]}
                />
                <BlockSpacer height={'5px'}/>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請者'}
                    items={[applicantRoom, `${applicantFamilyName} ${applicantFirstName}`]}
                />
            </>
        }
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'解約する区画'}
            items={[`${withdrawalArea}`]}
        />
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'解約日'}
            items={[`${withdrawalDateLabel}`]}
        />
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'バイク搬出日'}
            items={[`${bikeCarryingOutDateLabel}`]}
        />
    </>)
}

NatResidentBikeParkingUseWithdrawalApplyConfirm.displayName = 'NatResidentBikeParkingUseWithdrawalApplyConfirm'
export default NatResidentBikeParkingUseWithdrawalApplyConfirm